// エラーメッセージ表示
import {BaseApiResponse} from "../../swagger";
import {Alert} from "antd";
import React from 'react';
import {ErrorMap} from "../../store/common/Errors/ErrorsStore";

// error リストの連想配列をエラー表示
export function renderErrorMapMessage(errorMap: ErrorMap) {
  return (
    <>
      {errorMap && Array.from(errorMap.keys()).map((errorCategory) => {
        let errors = errorMap.get(errorCategory);
        return errors && errors.map((data, index) => {
          return <Alert key={index} style={{marginBottom: 24}} message={data.message} type="error" showIcon/>;
        });
      })}
    </>
  );
}

export function renderErrorMessage(formResponse: BaseApiResponse) {
  return (
    <>
      {formResponse.errors && formResponse.errors.map((data, index) => {
        return <Alert key={index} style={{marginBottom: 24}} message={data.message} type="error" showIcon/>;
      })}
    </>
  );
}

// ant design のフォームアイテムにエラーを設定する場合 setFields を使う。必要なとき実装する
// this.props.form.setFields({
//   user: {
//     value: values.user,
//     errors: [new Error('forbid ha')],
//   },
// });
